import { FontDefinition, FontStatus, UploadedFontData } from 'editor/src/store/fonts/types';

function uploadedFontToFontDefinition(uploaded: UploadedFontData): FontDefinition {
  return {
    status: FontStatus.new,
    metadata: {
      name: uploaded.name,
      fontFile: uploaded.fontFile,
      family: uploaded.family,
      weight: uploaded.weight,
      style: uploaded.style,
      fileUrl: uploaded.fileUrl || '',
      previewUrl: '',
      isPremium: false,
      unicodeBlockIndexes: [],
    },
    isPopular: false,
    isEmbroidery: false,
    isUploaded: true,
  };
}

export default uploadedFontToFontDefinition;
